import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { BottomNav } from './components/BottomNav';
import { Home } from './pages/Home';
import { Settings } from './pages/Settings';
import { Analyze } from './pages/Analyze';
import { Savings } from './pages/Savings';
import { BudgetDetails } from './pages/BudgetDetails';
import Login from './pages/Login';
import Register from './pages/Register';
import LoadingScreen from './components/LoadingScreen';

function AppLayout() {
  const location = useLocation();
  const { isLoading } = useAuth();
  
  // Show BottomNav only on protected pages
  const showNav = location.pathname === '/' || location.pathname === '/settings' || location.pathname === '/analyze' || location.pathname === '/savings';
  
  // Show loading screen during initial auth check
  if (isLoading) {
    return <LoadingScreen message="Starting up..." />;
  }
  
  return (
    <div className="bg-white min-h-screen w-full max-w-4xl mx-auto relative">
      <Routes>
        <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/analyze" element={<ProtectedRoute><Analyze /></ProtectedRoute>} />
        <Route path="/savings" element={<ProtectedRoute><Savings /></ProtectedRoute>} />
        <Route path="/budget/:budgetId" element={<ProtectedRoute><BudgetDetails /></ProtectedRoute>} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {showNav && <BottomNav />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppLayout />
      </Router>
    </AuthProvider>
  );
}

export default App;
